import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

import Loader from "./components/Loader";
import ImergeyWebsite from "./pages/home/Index";
import PublicBlogArticle from "./pages/blog/PublicBlogArticle";
import BookDemo from "./pages/home/BookDemo";
import NotFound from "./pages/home/NotFound";
import DemoChatWidget from "./components/DemoChatWidget";
import ScrollProgressBar from "./components/ScrollProgressBar";

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer />
      </BrowserRouter>
    </Suspense>
  );
}

const AppRoutes = () => {
  const location = useLocation();
  const path = location.pathname;
  // /book-demo already has the full booking experience, and the 404 page
  // shares its dark theme — the light widget would clash on both, so it
  // only shows on the light-themed pages (home + blog).
  const showWidget = path === "/" || path.startsWith("/blog/");

  return (
    <>
      <ScrollProgressBar />
      <Routes>
        <Route path="/" element={<ImergeyWebsite />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/blog/client/:id/:blogSlug?" element={<PublicBlogArticle />} />
        <Route path="/blog/:blogSlug" element={<PublicBlogArticle />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {showWidget && <DemoChatWidget />}
    </>
  );
};

export default App;
